<template>
  <v-dialog
    persistent
    v-model="show"
    max-width="880"
    content-class="popup-wrap-1"
  >
    <div class="pa-8">
      <h3 class="title-type-4 mb-2">{{ campaign.name }} 캠페인 현황</h3>

      <p class="form-coment-1 mt-3">
        <v-icon>mdi-alert-circle-outline</v-icon>
        선택한 캠페인의 매체별 지면 스케줄 현황입니다.
      </p>
      <div class="scroll-wrap">
        <table class="data-table-1">
          <colgroup>
            <col width="150px" />
            <col width="150px" />
            <col width="190px" />
            <col width="100px" />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="row">매체명</th>
              <th scope="row">지면명</th>
              <th scope="row">집행 기간</th>
              <th scope="row">잔여일</th>
              <th scope="row">소재 구분</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(media, i) in campaign.medias" :key="i">
              <th scope="row">
                {{ media.name }}
              </th>
              <td class="pa-0 table-background" colspan="4">
                <table style="width: 100%" class="inner-table">
                  <colgroup>
                    <col width="150px" />
                    <col width="190px" />
                    <col width="100px" />
                    <col />
                  </colgroup>
                  <tbody>
                    <tr v-for="(inventory, j) in media.inventories" :key="j">
                      <td>{{ inventory.name }}</td>
                      <td>
                        {{ inventory.start_at | moment('YYYY.MM.DD') }} -
                        {{ inventory.end_at | moment('YYYY.MM.DD') }}
                      </td>
                      <td>
                        <div v-if="inventory.remainsDays > 0">
                          {{ inventory.remainsDays }} 일 남음
                        </div>
                        <div v-else>-</div>
                      </td>
                      <td>
                        <div v-if="inventory.lineitems[0].lris.length > 0">
                          <div
                            v-for="(lri, k) in inventory.lineitems[0].lris"
                            :key="k"
                          >
                            <div v-if="lri.resources.length > 0">
                              <ul class="resource-list-type">
                                <li
                                  v-for="(resource, l) in lri.resources"
                                  :key="l"
                                >
                                  {{ resource.name }}
                                </li>
                              </ul>
                            </div>
                            <div v-else>-</div>
                          </div>
                        </div>
                        <div v-else>-</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-center mt-8">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click="show = false"
        >
          확인
        </v-btn>
      </div>
      <PreviewModal
        v-model="showPreview"
        :propsItem="previewItem"
      ></PreviewModal>
    </div>
  </v-dialog>
</template>

<script>
import PreviewModal from '@/components/modal/PreviewModal.vue';
export default {
  components: {
    PreviewModal,
  },
  props: {
    value: Boolean,
    propsCampaign: Object,
  },
  data: () => ({
    showPreview: false,
    previewItem: {},
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    campaign: {
      get() {
        let today = this.$moment(new Date());
        this.propsCampaign.medias.map(media => {
          media.inventories.forEach(inventory => {
            inventory.remainsDays = 0;
            let endDate = this.$moment(inventory.end_at);

            inventory.remainsDays = endDate.diff(today, 'days');
          });
        });
        return this.propsCampaign;
      },
      set(value) {
        this.propsCampaign = value;
      },
    },
  },
  methods: {
    preview(item) {
      this.showPreview = true;
      this.previewItem = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.previewImage {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 360px;
    max-height: 640px;
  }
}
.resource-list-type {
  li {
    line-height: 20px;
  }
}
.table-background {
  table.inner-table {
    tbody {
      tr:nth-child(odd) td {
        background: #fcfcfc !important;
      }
      tr:nth-child(even) td {
        background: #fff !important;
      }
    }
  }
}
//.scroll-wrap {
//	position: relative;
//	max-height: 780px;
//	overflow: auto;
//}
</style>
